export const formatNumber = (value) => {
  if (value === null || value === undefined) return '—';
  return Number(value).toLocaleString();
};

export const formatDate = (iso) => {
  if (!iso) return null;
  // last_show_date is a date-only string ("2026-08-02"); parse the parts as a
  // local date so it isn't shifted to the previous day in negative-offset zones.
  const [y, m, d] = iso.split('T')[0].split('-').map(Number);
  if (!y || !m || !d) return null;
  const date = new Date(y, m - 1, d);
  return date.toLocaleDateString('en-US', { month: 'short', day: '2-digit', year: 'numeric' });
};

const AVATAR_HUES = [12, 145, 210, 265, 320, 42, 190, 95];

// Deterministic avatar color from the artist name so a row keeps its color.
export const avatarColor = (name) => {
  let hash = 0;
  for (let i = 0; i < (name || '').length; i += 1) {
    hash = (hash * 31 + name.charCodeAt(i)) % 997;
  }
  const hue = AVATAR_HUES[hash % AVATAR_HUES.length];
  return `hsl(${hue}, 58%, 48%)`;
};

export const initial = (name) => (name || '?').trim().charAt(0).toUpperCase() || '?';
